var React = require('react');

function IconUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0638 7.00274C12.2663 7.01526 12.4587 7.09528 12.6105 7.22981L21.6962 15.4079C21.8768 15.5695 21.9857 15.7966 21.9987 16.0385C22.0118 16.2807 21.9278 16.518 21.7656 16.6982C21.6035 16.8784 21.3761 16.9865 21.1341 16.9988C20.892 17.0112 20.6549 16.9266 20.4753 16.7638L12 9.1326L3.52474 16.7638C3.34507 16.9266 3.10806 17.0112 2.86595 16.9988C2.62385 16.9865 2.39649 16.8784 2.23441 16.6982C2.07217 16.518 1.98819 16.2807 2.00134 16.0385C2.01433 15.7966 2.12318 15.5695 2.30381 15.4079L11.3895 7.22981C11.5741 7.06565 11.8176 6.98357 12.0638 7.00274Z","fill":"black"}));
}

IconUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconUp;

IconUp.default = IconUp;
